import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const STRIKE_OUT_BUTTON_WITH_COLOR_HEIGHT = 40;
const COLOR_RADIUS = 14;
const style = () => {
    const { borderRadiusFull, space05, space2, space4 } = theme();
    return StyleSheet.create({
        button: {
            alignItems: "center",
            borderRadius: borderRadiusFull,
            flexDirection: "row",
            gap: space2,
            justifyContent: "flex-start",
            minHeight: STRIKE_OUT_BUTTON_WITH_COLOR_HEIGHT,
            paddingHorizontal: space4,
            paddingVertical: space2,
        },
        buttonText: {
            textDecorationLine: "line-through",
        },
        color: {
            borderRadius: borderRadiusFull,
            height: COLOR_RADIUS,
            width: COLOR_RADIUS,
        },
        container: {
            flex: 1,
        },
        text: {
            paddingTop: space05,
        },
    });
};
export { style };
